import { type IReactionDisposer, makeAutoObservable, reaction } from 'mobx'

import type { IEntitiesStore } from 'entities/EntitiesExport'
import { ChatbotAnalyticDetailStore } from './chatbotAnalyticDetailStore'
import { ChatbotAnalyticListStore } from './chatbotAnalyticListStore'

export class ChatbotAnalyticStore {
  private _loading = true

  private readonly _list: ChatbotAnalyticListStore
  private readonly _details: ChatbotAnalyticDetailStore

  private readonly _disposeLoading: IReactionDisposer | null = null
  private readonly _disposeDetailsData: IReactionDisposer | null = null

  constructor(public id: number, private _entities: IEntitiesStore) {
    this._list = new ChatbotAnalyticListStore(id, this._entities)
    this._details = new ChatbotAnalyticDetailStore(id, this._entities)

    makeAutoObservable(this)

    this._disposeLoading = reaction(
      () => [this._list.initialLoading, this._details.initialLoading],
      ([listLoading, detailsLoading]) => {
        this._loading = listLoading || detailsLoading
      }
    )

    this._disposeDetailsData = reaction(
      () => this._details.data,
      (detailsData) => {
        this._list.calendarFilterStore.updateCreatedAt(detailsData?.created_at || null)
        this._list.calendarFilterStore.setFromFilterDefaultDate()
      }
    )
  }

  dispose = () => {
    this._disposeLoading?.()
    this._disposeDetailsData?.()

    this._list.dispose()
    this._details.dispose()
  }

  get loading() {
    return this._loading
  }

  get details() {
    return this._details
  }

  get list() {
    return this._list
  }
}
